import { pluck, distinctUntilChanged } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Playback>} playbackUpdate$
 * @return {Observable<void>}
 */

const createEndedStream = playbackUpdate$ =>
    playbackUpdate$
        .pipe(
            pluck('hasEnded'),
            distinctUntilChanged()
        );

export default createEndedStream;
